/* eslint-disable @next/next/no-img-element */
import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";
import { FeaturedBrand } from "@/types/General";

interface HomePromotion2Props {
  items: FeaturedBrand[];
}

function HomePromotion2({ items }: HomePromotion2Props) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);
  const settings = {
    infinite: items.length > 3,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay:true,
    autoplaySpeed:3000,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          infinite: items.length > 2,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: items.length > 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="homePromotion2_sc">
        <div className="container">
          <Slider ref={sliderRef} {...settings} className="promotion_grid">
            {items.map((item, index) => (
              <div
                className="promotion_grid_bx"
                key={index}
                onClick={() => {
                  const hasAllKeys = item?.banner_links?.every(
                    (link) => link?.linkable_id && link?.linkable_type && link?.type
                  );

                  if (hasAllKeys) {
                    if (item?.type === "brand") {
                      router.push(
                        `/product/product-category?brandIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else if (item.type === "category") {
                      router.push(
                        `/product/product-category?categoryIds=${item?.id}&type=featured_brands`
                      );
                    } else if (item.type === "product") {
                      router.push(
                        `/product/product-category?productIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else {
                      router.push("/product/product-category?type=recommended");
                    }
                  } else {
                    router.push("/product/product-category?type=recommended");
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <figure>
                  <img src={item.image} alt={item.title || "promotion"} />
                </figure>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomePromotion2;
